import React from 'react';
import { createBrowserRouter, createRoutesFromElements, Navigate, Route, RouterProvider } from 'react-router-dom';
import { createTheme, CssBaseline, ThemeProvider } from '@mui/material';
import { Provider } from 'react-redux';
import { store } from './store';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import UserManagement from './pages/UserManagement';
import NurseList from './pages/NurseList';
import NurseDetail from './pages/NurseDetail';
import PatientList from './pages/PatientList';
import PatientDetail from './pages/PatientDetail';
import TalkRoomList from './pages/TalkRoomList';
import TalkRoomSummary from './pages/TalkRoomSummary';
import TalkPlanMasterList from './pages/TalkPlanMasterList';
import TalkPlanMasterDetail from './pages/TalkPlanMasterDetail';
import CertificationCodes from './pages/CertificationCodes';
import ChatMessageDeletionHistory from './pages/ChatMessageDeletionHistory';
import CouponList from './pages/CouponList';
import CouponUsageList from './pages/CouponUsageList';
import Profile from './pages/Profile';
import UserList from './pages/UserList';
import ProtectedRoute from './components/ProtectedRoute';
import { ActionNotifier, AppUpdateNotifier } from './components/common';
import './App.css';
// MUIテーマの作成
const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
    background: {
      default: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
  },
});
// ルート定義
const routes = createRoutesFromElements(
  <>
    <Route path="/login" element={<Login/>}/>
    <Route element={<ProtectedRoute/>}>
      <Route path="/" element={<Navigate to="/dashboard" replace/>}/>
      <Route path="/dashboard" element={<Dashboard/>}/>
      <Route path="/manage/users" element={<UserManagement/>}/>
      <Route path="/nurses" element={<NurseList/>}/>
      <Route path="/nurses/:id" element={<NurseDetail/>}/>
      <Route path="/patients" element={<PatientList/>}/>
      <Route path="/patients/:id" element={<PatientDetail/>}/>
      <Route path="/talk_rooms" element={<TalkRoomList/>}/>
      <Route path="/talk_rooms/summary" element={<TalkRoomSummary/>}/>
      <Route path="/users" element={<UserList/>}/>
      <Route path="/settings/certification-codes" element={<CertificationCodes/>}/>
      <Route path="/coupons" element={<CouponList/>}/>
      <Route path="/coupons/:id/usages" element={<CouponUsageList/>}/>
      <Route path="/talk_plan_masters" element={<TalkPlanMasterList/>}/>
      <Route path="/talk_plan_masters/:id" element={<TalkPlanMasterDetail/>}/>
      <Route path="/activity/chat-message-deletion-history" element={<ChatMessageDeletionHistory/>}/>
      <Route path="/profile" element={<Profile/>}/>
    </Route>
    <Route path="*" element={<Navigate to="/login" replace/>}/>
  </>
);
// フューチャーフラグを含むルーター作成
const router = createBrowserRouter(routes, {
  future: {
    v7_relativeSplatPath: true
  }
});
const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline/> {/* MUIのリセットCSS */}
      <Provider store={store}>
        <RouterProvider router={router}/>
        <AppUpdateNotifier/>
        <ActionNotifier/>
      </Provider>
    </ThemeProvider>
  );
};
export default App;
